import { create } from "zustand";
import { toast } from "react-toastify";
import api from "../../utils/api";
import { useVehiclesSocketStore } from "../../store/admin/vehiclesSocketStore";
import { useUnitsStore } from "../../store/admin/unitsStore";

// Garaje: UNA ventana para toda la app (mapa, lista, Administración). Quien
// quiera cambiar el vehículo de una unidad sólo llama openGarage(...).
export interface GarageTarget {
  vehicleId: string;
  name: string;
  bodyType?: string;
  current?: string;
}

export const useVehicleGarage = create<{
  target: GarageTarget | null;
  open: (t: GarageTarget) => void;
  close: () => void;
}>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));

const applyLocal = (vehicleId: string, pointerModel: string) => {
  useVehiclesSocketStore.setState((s) => ({
    vehicles: s.vehicles.map((v) =>
      v.vehicle_id === vehicleId ? { ...v, vehicle: { ...v.vehicle, pointerModel } } : v,
    ),
  }));
  useUnitsStore.getState().updateUnitInStore(vehicleId, { pointer_model: pointerModel } as never);
};

/**
 * Guarda el modelo del vehículo. Optimista: el mapa y Administración cambian
 * al instante; si el servidor falla, se regresa al anterior y se avisa.
 */
export async function savePointerModel(vehicleId: string, pointerModel: string, previous: string) {
  applyLocal(vehicleId, pointerModel);
  try {
    await api.put(`/vehiclePointerModel?id=${encodeURIComponent(vehicleId)}`, { pointer_model: pointerModel });
    return true;
  } catch {
    applyLocal(vehicleId, previous);
    toast.error("No se pudo guardar el vehículo. Intenta de nuevo.");
    return false;
  }
}
